import React, { Component } from 'react'
import Modal from './Modal'
import Login from '../components/Login'

const BACKEND_AUTH_URL = 'https://auth.funoro.com'

class LoginModal extends Component {
  render () {
    return (
      <Modal title='Login now'>
        <Login />
      </Modal>
    )
  }
}

export default LoginModal



// WEBPACK FOOTER //
// ./src/containers/LoginModal.js